import createFetchClient from 'openapi-fetch';
import type { paths } from './schema.generated';

export type CreateChatApiOptions = {
    baseUrl: string;
    /** Returns the `Authorization` header value (e.g. `Session <token>`), read per request. */
    getAuthorizationHeader: () => string;
};

/**
 * The typed chat client: `openapi-fetch` over the generated `paths`.
 *
 * Deliberately no react-query layer. The chat reads history exactly once and then
 * maintains the conversation locally, so caching, invalidation, background refetching
 * and window-focus revalidation are all things we actively do not want — a refetch
 * behind the customer's back would either duplicate messages already appended locally
 * or silently replace a thread they are mid-conversation in. Recovery from divergence
 * is a deliberate full page reload, not a cache refresh.
 */
export function createChatApi({ baseUrl, getAuthorizationHeader }: CreateChatApiOptions) {
    const client = createFetchClient<paths>({ baseUrl });

    client.use({
        onRequest({ request }) {
            request.headers.set('Authorization', getAuthorizationHeader());
            return request;
        },
    });

    return client;
}

export type ChatApi = ReturnType<typeof createChatApi>;
